<div id="VerSolicitudEndosos">
    <div id="quotes-life" class="quotes-life" *ngIf="templateView==1">
        <h2 class="mt-3 font-weight-bolder">
            <div class="row">
                <div class="col-10">
                    <i class="fa fa-shield-alt text-mid-dark font-size-h1"></i> 
                    <span *ngIf="!VerEvaluacionCotizacionVida">{{ "QUOTES.QUOTESOFLIFE" | translate }}</span>
                    <span *ngIf="VerEvaluacionCotizacionVida">{{ "QUOTES.QUOTESCZ" | translate }}</span>
                </div>
                <div class="col text-right">
                    <button *ngIf="!VerEvaluacionCotizacionVida" class="btn btn-warning" (click)="submitNewquote()">{{ "QUOTES.NEWQUOTE" | translate }}</button>
                </div>
            </div>
        </h2>

        <div class="card card-custom gutter-b mt-10">
            <div class="card-body py-0 px-0">
                <div class="row mx-3">
                    <div class="col-md-12 mt-5">
                        <span class="font-weight-boldest font-size-h6 text-dark-50">{{ "MENU.H4FILTER" | translate}}</span>
                    </div>
                </div>
                <div class="form-group row mx-3 justify-content-md-left">
                    
                    <div class="col-md-12 my-5 ">
                        <form
                        [formGroup]="filterQuoteForm"
                        (ngSubmit)="submitFilterQuote()"
                        >
                            <div class="row mb-4">
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label class="sr-only">{{ "INSURANCE.INSURED" | translate }}</label>
                                        <input class="form-control" placeholder="{{ 'INSURANCE.INSURED' | translate }}" formControlName="inputAsegurado" name="inputAsegurado">
                                    </div>
                                </div>
                                
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label class="sr-only">{{ "QUOTES.QUOTEID" | translate }}</label>
                                        <input class="form-control" placeholder="{{ 'QUOTES.QUOTEID' | translate }}" formControlName="inputNroCotizacion" name="inputNroCotizacion">
                                    </div>
                                </div>

                                <div class="col-md-4">
                                    <div class="row">
                                        <div class="col-md-6">
                                            <div class="form-group kt-form__group">
                                                <label class="sr-only">{{ "INPUT.DATESTART" | translate }}</label>
                                                <div class="input-group">
                                                    <input class="form-control" formControlName="inputFechaDesde" name="inputFechaDesde" placeholder="" ngbDatepicker #d1="ngbDatepicker" autocomplete="false" readonly>
                                                    <div class="input-group-append">
                                                    <button class="btn btn-primary" (click)="d1.toggle()" type="button">
                                                        <i class="fa fa-calendar"></i>
                                                    </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="col-md-6">
                                            <div class="form-group kt-form__group">
                                                <label class="sr-only">{{ "INPUT.DATEEND" | translate }}</label>
                                                <div class="input-group">
                                                    <input class="form-control" formControlName="inputFechaHasta" name="inputFechaHasta" placeholder="" ngbDatepicker #d2="ngbDatepicker" autocomplete="false" readonly>
                                                    <div class="input-group-append">
                                                    <button class="btn btn-primary" (click)="d2.toggle()" type="button">
                                                        <i class="fa fa-calendar"></i>
                                                    </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-2">
                                    <div class="form-group">
                                        <label class="sr-only">{{ "INPUT.AGE" | translate }}</label>
                                        <input class="form-control" placeholder="{{ 'INPUT.AGE' | translate }}" formControlName="inputEdad" name="inputEdad">
                                    </div>
                                </div>

                                <div class="col-md-3" *ngIf="VerEvaluacionCotizacionVida">
                                    <div class="form-group">
                                        <label class="sr-only">{{ "INPUT.AGENT" | translate }}</label>
                                        <input class="form-control" placeholder="{{ 'INPUT.AGENT' | translate }}" formControlName="inputAgente" name="inputAgente">
                                    </div>
                                </div>
                                
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label class="sr-only">{{ "INPUT.STATUS" | translate }}</label>
                                        <select class="form-control" placeholder="" name="inputIdEstatus" formControlName="inputIdEstatus">
                                            <option value="">{{ "INPUT.SELECT" | translate }}</option>
                                            <option *ngFor="let item of estatus | async" value="{{item.IdEstatus}}">{{item.Estatus}}</option>
                                        </select>
                                    </div>
                                </div>
                            </div>

                    

                            <hr>

                            <div class="row justify-content-end">
                                <div class="col-md-6 ">
                                    <div class="row">
                                        <div class="col-md-12 text-left" >
                                            <div class="form-group mb-0">
                                                <button [disabled]="activeSubmitFilterQuote" type="button" class="btn btn-primary font-weight-boldest" value="print" (click)="submitFilterQuoteReport(loadingModal)">{{ "GENERAL.REPORTPRINT" | translate }}</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-md-6 ">
                                    <div class="row">
                                        <div class="col-md-12">
                                            <div class="form-group mb-0 text-right">
                                                <button [disabled]="activeSubmitFilterQuote" type="submit" class="btn btn bg-success text-white font-weight-boldest  mr-2" value="filter" >{{ "INPUT.FILTER" | translate }}</button>
                                                <button type="reset" class="btn btn-default text-dark-50 font-weight-boldest ">{{ "INPUT.RESET" | translate }}</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </form>
                    </div>
                </div>
            </div>
        </div>

        <div class="card card-custom gutter-b my-10">
            <div class="card-header d-none">
                <div class="card-title">
                    <h3 class="card-label">{{ "GENERAL.LISTING_INSURANCE" | translate }}</h3>
                </div>
            </div>
            
            <div class="card-body py-0 px-0">
                <div class="table-responsive angular-bootstrap-table">
                    <table class="table table-head-custom table-vertical-center overflow-hidden" style="border-radius: 0.42rem;">
                        <thead style="background-color: rgb(130,124,120);color:white;">
                            <th class="text-light">{{ "QUOTES.QUOTEID" | translate }}</th>
                            <th class="text-light">{{ "INSURANCE.INSURED" | translate }}</th>
                            <th>{{ "INPUT.AGE" | translate }}</th>
                            <th>{{ "INSURANCE.SUMA_ASEGURADA" | translate }}</th>
                            <th>{{ "INSURANCE.PRIMAYEARLY" | translate }}</th>
                            <th>{{ "INSURANCE.PRIMAMONTHLY" | translate }}</th>
                            <th *ngIf="VerEvaluacionCotizacionVida">{{ "INPUT.AGENT" | translate }}</th>
                            <th>{{ "INPUT.DATE" | translate }}</th>
                            <th >{{ "INSURANCE.STATUS" | translate }}</th>
                            <th width="15%">{{ "INSURANCE.OPTIONS" | translate }}</th>
                        </thead>
                        <tbody>
                            <tr *ngFor="let item of quoteService.items$ | async; let i = index">
                                <td>{{ item.NroCotizacion }}</td>
                                <td>{{ item.Asegurado }}</td>
                                <td>{{ item.Edad }}</td>
                                <td>{{ item.SumaAsegurada }}</td>
                                <td>{{ item.PrimaAnualTotalNivelada  | currency:"$" }}</td>
                                <td>{{ item.PrimaMensualTotalNivelada  | currency:"$" }}</td>
                                <td  *ngIf="VerEvaluacionCotizacionVida">{{ item.Corredor }}</td>
                                <td>{{ item.FechaCreacion | date: 'MM/dd/yyyy' }}</td>
                                <td>{{ item.Estatus }}</td>
                                <td>
                                    <button type="button" class="btn pr-1" (click)="clickView(item.IdCotizacion,2)" data-toggle="tooltip" title='{{ "QUOTES.QUOTEVIEW" | translate }}'><i class="fas fa-edit"></i></button>
                                    <button (click)="downloadDocumentQuote(loadingModal, item.IdCotizacion)" type="button" class="btn" title='{{ "QUOTES.PRINT" | translate }}'><i class="fas fa-print"></i></button>
                                </td>
                            </tr>
                        </tbody>
                        <tfoot>
                            <tr *ngIf="!quoteService.items$" class="">
                                <td>
                                    <div>
                                        <strong>{{"GENERAL.EMPTY_QUERY" | translate}}</strong>
                                    </div>
                                </td>
                            </tr>
                        </tfoot>
                    </table>
                </div>
            </div>
        </div>
    </div>

    <div id="view-quote" *ngIf="templateView==2" class="mb-5">
        <div class="row">
            <div class="col-md-6 col-sm-12">
                <h2 class="font-weight-bolder">
                    <i class="fa fa-shield-alt text-mid-dark font-size-h1"></i>
                    <span *ngIf="!VerEvaluacionCotizacionVida">{{ "QUOTES.QUOTESOFLIFE" | translate }}</span>
                    <span *ngIf="VerEvaluacionCotizacionVida">{{ "QUOTES.QUOTESCZ" | translate }}</span>
                </h2>
            </div>
            <div class="col-md-6 col-sm-12">
                
            </div>
        </div>

        <div class="card card-custom gutter-b mt-10">
            <div class="card-header d-none">
                <div class="card-title">
                    <h3 class="card-label">{{ "GENERAL.QUOTE_VIEW" | translate }}</h3>
                </div>
            </div>
            <div class="card-body py-0 px-0" >
                <div id="quote-error" class="alert alert-warning round-0 rounded-top font-weight-bolder" [hidden]="!quoteHasErrorSubject.hasError">
                    {{"QUOTES.ERROR1" | translate}}
                </div>
                <form
                    [formGroup]="quoteForm"
                    (ngSubmit)="submitQuote(loadingModal)"
                        >
                    <div class="row mx-5 my-5">
                        <div class="col-md-2">
                            <div class="form-group">
                                <label class="-sr-only">{{ "QUOTES.QUOTEID" | translate }}</label>
                                <input class="form-control bg-secondary text-black font-weight-bolder" placeholder="" name="inputNroCotizacion" formControlName="inputNroCotizacion" readonly>
                                <input type="hidden" name="inputIdCotizacion" formControlName="inputIdCotizacion">
                            </div>
                        </div>

                        <div class="col-md-6">
                            <div class="form-group">
                                <label class="-sr-only">{{ "INSURANCE.INSUREDFULLNAME" | translate }}</label>
                                <input class="form-control" placeholder="" formControlName="inputAsegurado" name="inputAsegurado"
                                [ngClass]="{ 'is-invalid': quoteForm.controls['inputAsegurado'].invalid }">
                                <ng-container
                                    [ngTemplateOutlet]="formError"
                                    [ngTemplateOutletContext]="{
                                    validation: 'required',
                                    message: 'Campo requerido.',
                                    control: quoteForm.controls['inputAsegurado']
                                    }"
                                ></ng-container>
                            </div>
                        </div>

                        <!--div class="col-md-3">
                            <div class="form-group kt-form__group">
                                <label class="-sr-only">{{ "INPUT.BIRTHDATE" | translate }}</label>
                                <div class="input-group">
                                    <input class="form-control" name="inputFechaNacimiento" formControlName="inputFechaNacimiento" placeholder="" ngbDatepicker #d="ngbDatepicker"
                                    [ngClass]="{ 'is-invalid': quoteForm.controls['inputFechaNacimiento'].invalid }" requiered>
                                    <div class="input-group-append">
                                    <button class="btn btn-primary" (click)="d.toggle()" type="button">
                                        <i class="fa fa-calendar"></i>
                                    </button>
                                    </div>
                                    <ng-container
                                    [ngTemplateOutlet]="formError"
                                    [ngTemplateOutletContext]="{
                                    validation: 'required',
                                    message: 'Campo requerido.',
                                    control: quoteForm.controls['inputFechaNacimiento']
                                    }"
                                ></ng-container>
                                </div>
                            </div>
                        </div -->

                        <div class="col-md-2">
                            <div class="form-group">
                                <label class="-sr-only">{{ "AUTH.REGISTER.NROIDENTIFICACION" | translate }}</label>
                                <input class="form-control" placeholder="" formControlName="inputIdentificacion" name="inputIdentificacion">
                            </div>
                        </div>

                    
                        <div class="col-md-2">
                            <div class="form-group">
                                <label class="-sr-only">{{ "INPUT.GENDER" | translate }}</label>
                                <select class="form-control" placeholder="" name="inputSexo" formControlName="inputSexo"
                                    [ngClass]="{ 'is-invalid': quoteForm.controls['inputSexo'].invalid }" requiered>
                                    <option value="">{{ "INPUT.SELECT" | translate }}</option>
                                    <option *ngFor="let item of genero | async" value="{{item.IdSexo}}">{{item.Sexo}}</option>
                                </select>
                                <ng-container
                                    [ngTemplateOutlet]="formError"
                                    [ngTemplateOutletContext]="{
                                    validation: 'required',
                                    message: 'Campo requerido.',
                                    control: quoteForm.controls['inputSexo']
                                    }"
                                ></ng-container>
                            </div>
                        </div>
                    </div>

                    <div class="row mx-5  my-3">
                        
                        <div class="col-md-2">
                            <div class="form-group">
                                <label class="-sr-only">{{ "INPUT.MOBILE" | translate }}</label>
                                <input type="phone" class="form-control" placeholder="" formControlName="inputCelular" name="inputCelular"
                                [ngClass]="{ 'is-invalid': quoteForm.controls['inputCelular'].invalid }">
                                <ng-container
                                    [ngTemplateOutlet]="formError"
                                    [ngTemplateOutletContext]="{
                                    validation: 'required',
                                    message: 'Campo requerido.',
                                    control: quoteForm.controls['inputCelular']
                                    }"
                                ></ng-container>
                            </div>
                        </div>

                        <div class="col-md-4">
                            <div class="form-group">
                                <label class="-sr-only">{{ "INPUT.EMAIL" | translate }}</label>
                                <input class="form-control" placeholder="" name="inputEmail" formControlName="inputEmail">
                            </div>
                        </div>
                    </div>

                    <hr>

                    <div class="row mx-5 my-3">

                        <div class="col-md-2">
                            <div class="form-group">
                                <label class="-sr-only">{{ "INPUT.AGE2" | translate }}</label>
                                <input class="form-control" placeholder="" formControlName="inputEdad" name="inputEdad"
                                [ngClass]="{ 'is-invalid': quoteForm.controls['inputEdad'].invalid }">
                                <ng-container
                                    [ngTemplateOutlet]="formError"
                                    [ngTemplateOutletContext]="{
                                    validation: 'required',
                                    message: 'Campo requerido.',
                                    control: quoteForm.controls['inputEdad']
                                    }"
                                ></ng-container>
                            </div>
                        </div>

                        <div class="col-md-2">
                            <div class="form-group">
                                <label class="-sr-only">{{ "INPUT.SMOKER" | translate }}</label>
                                <select class="form-control" placeholder="" name="inputEsFumador" formControlName="inputEsFumador"
                                    [ngClass]="{ 'is-invalid': quoteForm.controls['inputEsFumador'].invalid }" required>
                                    <option value="">{{ "INPUT.SELECT" | translate }}</option>
                                    <option *ngFor="let item of fumador | async" value="{{item.IdEsFumador}}">{{item.EsFumador}}</option>
                                </select>
                                <ng-container
                                    [ngTemplateOutlet]="formError"
                                    [ngTemplateOutletContext]="{
                                    validation: 'required',
                                    message: 'Campo requerido.',
                                    control: quoteForm.controls['inputEsFumador']
                                    }"
                                ></ng-container>
                            </div>
                        </div>

                        <div class="col-md-3">
                            <div class="form-group">
                                <label class="-sr-only">{{ "INSURANCE.QUALIFICATION" | translate }}</label>
                                <div class="input-group">
                                    <input type="text" class="form-control"  name="inputClasificacion" formControlName="inputClasificacion"
                                    [ngClass]="{ 'is-invalid': quoteForm.controls['inputClasificacion'].invalid }" required>
                                    <div class="input-group-append"><span class="input-group-text"><i class="fas fa-info-circle text-primary" placement="top" ngbTooltip="No puede ser menor que 100 y mayor que 300."></i></span></div>
                                </div>
                                <ng-container
                                    [ngTemplateOutlet]="formError"
                                    [ngTemplateOutletContext]="{
                                    validation: 'required',
                                    message: 'Campo requerido',
                                    control: quoteForm.controls['inputClasificacion']
                                    }"
                                ></ng-container>
                                <ng-container
                                    [ngTemplateOutlet]="formError"
                                    [ngTemplateOutletContext]="{
                                    validation: 'min',
                                    message: 'No puede ser menor a 100',
                                    control: quoteForm.controls['inputClasificacion']
                                    }"
                                ></ng-container>
                                <ng-container
                                    [ngTemplateOutlet]="formError"
                                    [ngTemplateOutletContext]="{
                                    validation: 'max',
                                    message: 'No puede ser mayor a 300',
                                    control: quoteForm.controls['inputClasificacion']
                                    }"
                                ></ng-container>
                            </div>
                        </div>

                        <div class="col-md-2">
                            <div class="form-group">
                                <label class="-sr-only">{{ "INSURANCE.TERM" | translate }}</label>
                                <div class="input-group">
                                    <input type="email" class="form-control" placeholder="" name="inputTermino" formControlName="inputTermino"
                                    [ngClass]="{ 'is-invalid': quoteForm.controls['inputTermino'].invalid }" required>
                                    <div class="input-group-append"><span class="input-group-text"><i class="fas fa-info-circle text-primary" placement="top" ngbTooltip="La suma de la edad con el plazo cobertura años no puede ser mayor que 80"></i></span></div>
                                </div>
                            </div>
                            <ng-container
                            [ngTemplateOutlet]="formError"
                            [ngTemplateOutletContext]="{
                            validation: 'min',
                            message: 'El término no puede ser menor de 10 años',
                            control: quoteForm.controls['inputTermino']
                            }"
                            ></ng-container>
                            <ng-container
                            [ngTemplateOutlet]="formError"
                            [ngTemplateOutletContext]="{
                            validation: 'required',
                            message: 'Campo requerido.',
                            control: quoteForm.controls['inputTermino']
                            }"
                            ></ng-container>
                            <ng-container
                            [ngTemplateOutlet]="formError"
                            [ngTemplateOutletContext]="{
                            validation: 'termValid',
                            message: 'La suma de la edad con el plazo cobertura años no puede ser mayor que 80 ni menor que 10.',
                            control: quoteForm.controls['inputTermino']
                            }"
                            ></ng-container>
                        </div>

                        <div class="col-md-2">
                            <div class="form-group">
                                <label class="-sr-only">{{ "INSURANCE.SURCHARGE" | translate }}</label>
                                <input type="text" class="form-control" name="inputRecargo" formControlName="inputRecargo"
                                [ngClass]="{ 'is-invalid': quoteForm.controls['inputRecargo'].invalid }" required>
                                <ng-container
                                    [ngTemplateOutlet]="formError"
                                    [ngTemplateOutletContext]="{
                                    validation: 'required',
                                    message: 'Campo requerido.',
                                    control: quoteForm.controls['inputRecargo']
                                    }"
                                ></ng-container>
                            </div>
                        </div>

                        <div class="col-md-12 my-3"></div>

                    </div>


                    <div class="row mx-5 my-3">

                        <div class="col-md-3">
                            <div class="form-group">
                                <label class="-sr-only">{{ "INSURANCE.SUMA_ASEGURADA" | translate }}</label>
                                <div class="input-group mb-3">
                                    <div class="input-group-prepend">
                                      <span class="input-group-text">$</span>
                                    </div>
                                    <input type="text" class="form-control font-weight-bolder" angularFormsCurrency prefix='' thousandsSeparator=',' decimalSeparator='' digitsAfterSeparator="0" name="inputSumaAsegurada" formControlName="inputSumaAsegurada"
                                    [ngClass]="{ 'is-invalid': quoteForm.controls['inputSumaAsegurada'].invalid }" required>
                                </div>
                                <ng-container
                                    [ngTemplateOutlet]="formError"
                                    [ngTemplateOutletContext]="{
                                    validation: 'required',
                                    message: 'Campo requerido.',
                                    control: quoteForm.controls['inputSumaAsegurada']
                                    }"
                                ></ng-container>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="form-group">
                                <label class="-sr-only">{{ "INSURANCE.SUMA_ASEGURADA_INCENDIO" | translate }}</label>
                                <div class="input-group mb-3">
                                    <div class="input-group-prepend">
                                      <span class="input-group-text">$</span>
                                    </div>
                                    <input type="text" class="form-control font-weight-bolder" placeholder="0"  angularFormsCurrency prefix='' thousandsSeparator=',' decimalSeparator='' digitsAfterSeparator='' name="inputSumaAseguradaIncendio" formControlName="inputSumaAseguradaIncendio"
                                    [ngClass]="{ 'is-invalid': quoteForm.controls['inputSumaAseguradaIncendio'].invalid }" required>
                                </div>
                                <ng-container
                                    [ngTemplateOutlet]="formError"
                                    [ngTemplateOutletContext]="{
                                    validation: 'required',
                                    message: 'Campo requerido.',
                                    control: quoteForm.controls['inputSumaAseguradaIncendio']
                                    }"
                                ></ng-container>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="form-group">
                                <label class="-sr-only">{{ "INSURANCE.SUMA_ASEGURADA_CONTENIDO" | translate }}</label>
                                <div class="input-group mb-3">
                                    <div class="input-group-prepend">
                                      <span class="input-group-text">$</span>
                                    </div>
                                    <input type="text" class="form-control font-weight-bolder" angularFormsCurrency prefix='' thousandsSeparator=',' decimalSeparator='' digitsAfterSeparator='' prefix='' thousandsSeparator=',' decimalSeparator='' digitsAfterSeparator="0" name="inputSumaAseguradaContenido" formControlName="inputSumaAseguradaContenido"
                                    [ngClass]="{ 'is-invalid': quoteForm.controls['inputSumaAseguradaContenido'].invalid }"  required>
                                </div>
                                <ng-container
                                    [ngTemplateOutlet]="formError"
                                    [ngTemplateOutletContext]="{
                                    validation: 'required',
                                    message: 'Campo requerido.',
                                    control: quoteForm.controls['inputSumaAseguradaContenido']
                                    }"
                                ></ng-container>
                            </div>
                        </div>
                        
                        <div class="col-md-3">
                            <div class="form-group">
                                <label class="-sr-only">{{ "INSURANCE.TYPEOFRISK" | translate }}</label>
                                <select class="form-control" placeholder="" name="inputTipoRiesgo" formControlName="inputTipoRiesgo" 
                                    [ngClass]="{ 'is-invalid': quoteForm.controls['inputTipoRiesgo'].invalid }" required>
                                    <option value="0">{{ "INPUT.DONTAPPLY" | translate }}</option>
                                    <option *ngFor="let item of tipoRiesgo | async" value="{{item.IdTipoRiesgo}}">{{item.TipoRiesgo}}</option>
                                </select>
                                <ng-container
                                    [ngTemplateOutlet]="formError"
                                    [ngTemplateOutletContext]="{
                                    validation: 'required',
                                    message: 'Campo requerido.',
                                    control: quoteForm.controls['inputTipoRiesgo']
                                    }"
                                ></ng-container>
                            </div>
                        </div>
                    </div>

					<div class="row mx-5 my-3">
						
						<div class="col-md-6">
                            <label class="-sr-only">{{ "INSURANCE.LOCATION_OF_RISK" | translate }}</label>
                            <input type="text" class="form-control" name="inputUbicacionRiesgo" formControlName="inputUbicacionRiesgo">
                        </div>

                        <div class="col-md-2">
                            <div class="form-group">
                                <label class="-sr-only" for="inputNroAnosPago">{{ "INSURANCE.SETPAYMENTYEARS" | translate }}</label>
                                <div class="input-group">
                                    <input type="text" class="form-control" placeholder="" name="inputNroAnosPago" formControlName="inputNroAnosPago" 
                                    [ngClass]="{ 'is-invalid': quoteForm.controls['inputNroAnosPago'].invalid }"
                                    required>
                                    <div class="input-group-append"><span class="input-group-text"><i class="fas fa-info-circle text-primary" placement="top" ngbTooltip="No pueda ser mayor al campo plazo cobertura años"></i></span></div>
                                 </div>
                            </div>
                            <ng-container
                                [ngTemplateOutlet]="formError"
                                [ngTemplateOutletContext]="{
                                validation: 'required',
                                message: 'Campo requerido.',
                                control: quoteForm.controls['inputNroAnosPago']
                                }"
                            ></ng-container>
                            <ng-container
                            [ngTemplateOutlet]="formError"
                            [ngTemplateOutletContext]="{
                            validation: 'anyosValid',
                            message: 'No puede ser negativo, cero o mayor al campo plazo cobertura años.',
                            control: quoteForm.controls['inputNroAnosPago']
                            }"
                            ></ng-container>
                        </div>

                        <div class="col-md-2">
                            <div class="form-group">
                                <label class="-sr-only">{{ "INPUT.PAYMENTCYCLE" | translate }}</label>
                                <select id="inputIdFrecuenciaPago" class="form-control" placeholder="" name="inputIdFrecuenciaPago" formControlName="inputIdFrecuenciaPago"
                                    [ngClass]="{ 'is-invalid': quoteForm.controls['inputIdFrecuenciaPago'].invalid }"
                                    (change)="changeFrecuenciaPago()" required>
                                    <option value="">{{ "INPUT.SELECT" | translate }}</option>
                                    <option *ngFor="let item of frecuenciaPago | async" value="{{item.IdFrecuenciaPago}}">{{item.FrecuenciaPago}}</option>
                                </select>
                                <ng-container
                                    [ngTemplateOutlet]="formError"
                                    [ngTemplateOutletContext]="{
                                    validation: 'required',
                                    message: 'Campo requerido.',
                                    control: quoteForm.controls['inputIdFrecuenciaPago']
                                    }"
                                ></ng-container>
                            </div>
                        </div>

                        <div class="col-md-2">
                            <div class="form-group">
                                <label class="-sr-only">{{ "INPUT.PAYMENTTYPE" | translate }}</label>
                                <select class="form-control" placeholder="" name="inputIdTipoPago" formControlName="inputIdTipoPago"
                                    [ngClass]="{ 'is-invalid': quoteForm.controls['inputIdTipoPago'].invalid }" required>
                                    <option value="">{{ "INPUT.SELECT" | translate }}</option>
                                    <option *ngFor="let item of tipoPago$ | async" value="{{item.IdTipoPago}}">{{item.TipoPago}}</option>
                                </select>
                                <ng-container
                                    [ngTemplateOutlet]="formError"
                                    [ngTemplateOutletContext]="{
                                    validation: 'required',
                                    message: 'Campo requerido.',
                                    control: quoteForm.controls['inputIdTipoPago']
                                    }"
                                ></ng-container>
                            </div>
                        </div>

                        <div class="col-md-12 my-3"></div>

                        <div class="col-md-6" *ngIf="VerEvaluacionCotizacionVida">
                            <div class="form-group">
                                <label class="-sr-only">{{ "QUOTES.REASONOFSURCHARGE" | translate }}</label>
                                <textarea class="form-control"  name="inputMotivoRecargo" formControlName="inputMotivoRecargo" row="10" style="width: 100%; min-height: 150px;"></textarea>
                            </div>
                        </div>
                    </div>

                    <div class="row mx-5 my-3">
                        <div class="col-md-6">
                            <div class="form-group row mt-5">
                                <div class="col-2 mt-2">
                                    <span class="switch switch-outline switch-icon switch-primary">
                                     <label>
                                      <input id="inputIdTienePolizaVida" type="checkbox" (change)="changeIdTienePolizaVida($event)" name="inputIdTienePolizaVida" formControlName="inputIdTienePolizaVida" />
                                      <span></span>
                                     </label>
                                    </span>
                                </div>
                                <label class="col-10 col-form-label mt-2">{{ "QUOTES.HASPOLICIELIFE" | translate }}</label>
                            </div>
                        </div>

                        <div class="col-md-3">
                            <div class="form-group">
                                <label class="-sr-only">{{ "INSURANCE.SUMA_ASEGURADA_POLIZA" | translate }}</label>
                                <div class="input-group mb-3">
                                    <div class="input-group-prepend">
                                      <span class="input-group-text">$</span>
                                    </div>
                                    <input type="text" id="inputSumaAseguraPolizaExistente" class="form-control font-weight-bolder" angularFormsCurrency prefix='' thousandsSeparator=',' decimalSeparator='' digitsAfterSeparator="0" name="inputSumaAseguraPolizaExistente" formControlName="inputSumaAseguraPolizaExistente"
                                    [ngClass]="{ 'is-invalid': quoteForm.controls['inputSumaAseguraPolizaExistente'].invalid }" required>
                                </div>
                                <ng-container
                                    [ngTemplateOutlet]="formError"
                                    [ngTemplateOutletContext]="{
                                    validation: 'required',
                                    message: 'Campo requerido.',
                                    control: quoteForm.controls['inputSumaAseguraPolizaExistente']
                                    }"
                                ></ng-container>
                            </div>
                        </div>

                    </div>

                    <div class="col-md-12 my-3"></div>

                    <hr>
                    <div class="row mx-5 my-5">
                        <div class="col-md-8 col-sm-12 mt-5"></div>
                        <div class="col-md-4 col-sm-12 mt-5 text-right">
                            <button type="button" class="btn btn-default text-dark-50 font-weight-boldest mr-2" (click)="clickView(1,1)">{{ "INPUT.CANCEL" | translate }}</button>
                            <button type="submit" class="btn btn-primary">{{ "QUOTES.QUOTE" | translate }}</button>
                        </div>
                    </div>
                </form>

            </div>
        </div>
    </div>

    <div id="view-result-quote" *ngIf="quoteResultOb$ | async as quote; else loadingQuote" class="mb-5" #target>
        <div class="card card-custom gutter-b mt-5">
            <div class="card-header">
                <div class="card-title">
                    <h3 class="card-label">{{ "QUOTES.QUOTEDETAILS" | translate }}</h3>
                </div>
            </div>

            <div class="card-body py-0 px-0">
                <div class="row mx-5 my-5">
                    <div class="col-md-9">
                        <div class="example">
                            <div class="example-preview" >

                                <table class="table table-head-custom table-vertical-center  table-striped overflow-hidden border-1">
                                    
                                    <tr>
                                        <th>{{ "INSURANCE.QP11" | translate }}</th>
                                        <td class="text-left">{{ quote.PrimaAnualBasicaSeguroVida  | currency:"$"}}</td>
                                    </tr>
                                    <tr>
                                        <th>{{ "INSURANCE.QP12" | translate }}</th>
                                        <td class="text-left">{{ quote.RecargoAnualAgravacionRiesgo | currency:"$"}}</td>
                                    </tr>
                                    <tr>
                                        <th>{{ "INSURANCE.QP13" | translate }}</th>
                                        <td class="text-left">{{ quote.PrimaAnualAdicionalSeguroVida  | currency:"$"}}</td>
                                    </tr>
                                    <tr>
                                        <th>{{ "INSURANCE.QP14" | translate }}</th>
                                        <td class="text-left">{{ quote.PrimaAnualBasicaBeneficiosAdicinales  | currency:"$" }}</td>
                                    </tr>
                                    <tr>
                                        <th>{{ "INSURANCE.QP20" | translate }}</th>
                                        <td class="text-left ">{{ quote.RecargoAnualFormaPago  | currency:"$"}}</td>
                                    </tr>
                                    <tr>
                                        <th>{{ "INSURANCE.QP15" | translate }}</th>
                                        <td class="text-left font-weight-bolder border-dark border-top font-weight-bolder" style="border-bottom: 0!important;">{{ quote.PrimaAnualTotalNivelada  | currency:"$"}}</td>
                                    </tr>
                                    <tr>
                                        <th>{{ "INSURANCE.QP16" | translate }} <span *ngIf="FrecuenciaSelected">(<span style="text-transform: uppercase;">{{FrecuenciaSelected}}</span>)</span></th>
                                        <td class="text-left font-weight-bolder">{{ quote.PrimaMensualTotalNivelada   | currency:"$"}}</td>
                                    </tr>
                                    
                                    <tr>
                                        <th>{{ "INSURANCE.QP17" | translate }}</th>
                                        <td class="text-left font-weight-bolder">{{ quoteForm.value.inputNroAnosPago}}</td>
                                    </tr>
                                    <tr>
                                        <th>{{ "INSURANCE.QP18" | translate }}</th>
                                        <td class="text-left font-weight-bolder">{{ quote.PrimaAnualAnosPagos  | currency:"$"}}</td>
                                    </tr>

                                    <tr>
                                        <th>{{ "INSURANCE.QP19" | translate }} <span *ngIf="FrecuenciaSelected">(<span style="text-transform: uppercase;">{{FrecuenciaSelected}}</span>)</span></th>
                                        <td class="text-left font-weight-bolder">{{ quote.PrimaMensualAnosPagos  | currency:"$"}} </td>
                                    </tr>
                                </table>

                                <!--
                                <table class="table table-head-custom table-vertical-center  table-striped overflow-hidden border-1">
                                    
                                    <tr>
                                        <th>{{ "INSURANCE.QP01" | translate }}</th>
                                        <td class="text-left">{{ quote.PrimaMensualBasicaSeguroVida  | currency:"$"}}</td>
                                    </tr>
                                    <tr>
                                        <th>{{ "INSURANCE.QP02" | translate }}</th>
                                        <td class="text-left">{{ quote.RecargoMensualAgravacionRiesgo  | currency:"$"}}</td>
                                    </tr>
                                    <tr>
                                        <th>{{ "INSURANCE.QP03" | translate }}</th>
                                        <td class="text-left">{{ quote.PrimaMensualAdicionalSeguroVida  | currency:"$"}}</td>
                                    </tr>
                                    <tr>
                                        <th>{{ "INSURANCE.QP04" | translate }}</th>
                                        <td class="text-left">{{ quote.PrimaMensualBasicaBeneficiosAdicinales  | currency:"$" }}</td>
                                    </tr>
                                    <tr class="d-none">
                                        <th>{{ "INSURANCE.QP05" | translate }}</th>
                                        <td class="text-left">{{ quote.PrimaMensualTotalNivelada  | currency:"$"}}</td>
                                    </tr>
                                    <tr  class="d-none">
                                        <th>{{ "INSURANCE.QP06" | translate }}</th>
                                        <td class="text-left">{{ quote.PrimaAnualTotalNivelada  | currency:"$"}}</td>
                                    </tr>
                                    <tr>
                                        <th>{{ "INSURANCE.QP07" | translate }}</th>
                                        <td class="text-left">{{ quoteForm.value.inputNroAnosPago}}</td>
                                    </tr>
                                    <tr>
                                        <th>{{ "INSURANCE.QP08" | translate }}</th>
                                        <td class="text-left">{{ quote.PrimaAnualAnosPagos  | currency:"$"}}</td>
                                    </tr>
                                </table>
                                -->

                            </div>
                        </div>
                    </div>


                    <div class="col-md-3">
                        <div class="example">
                            <div class="example-code">
                                <div class="row m-5 mt-0">
                                    <div class="col-md-12 col-sm-6 mt-5 mb-5">
                                        <button (click)="downloadDocumentQuote(loadingModal, quoteForm.value.inputIdCotizacion)" type="button" class="btn btn-primary btn-block">{{ "QUOTES.PRINTDETAILS" | translate }}</button>
                                    </div>
                                    <div class="col-md-12 col-sm-6 mt-5 mb-5" *ngIf="!VerEvaluacionCotizacionVida">
                                        <button type="button" class="btn btn-danger btn-block" (click)="onclickModalRequiredDocument(requiredDocumentModal)">{{ "DOCUMENTS.REQUIRED_DOCUMENTS" | translate }}</button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="example mt-5"  *ngIf="!VerEvaluacionCotizacionVida">
                            <div class="example-code">
                                <div class="row m-5">
                                    <div class="col-md-12 col-sm-6 mt-5 mb-5">
                                        <button type="button" class="btn btn-primary btn-block" (click)="onclickModalUploadRequiredDocument(requiredUploadDocumentModal)">{{ "DOCUMENTS.UPLOAD_REQUIRED_DOCUMENTS" | translate }}</button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row"  *ngIf="!VerEvaluacionCotizacionVida">
                            <div class="col-md-12 mt-5">
                                <button type="button" class="btn btn-success btn-block" (click)="onclickRequestQuote(loadingModal)">{{ "QUOTES.QUOTETOEMIT" | translate }}</button>
                            </div>
                        </div>

                        <div class="row"  *ngIf="VerEvaluacionCotizacionVida">
                            <div class="col-md-12 mt-5 mb-5">
                                <button type="button" class="btn btn-success btn-block" (click)="onclickModifyQuote(loadingModal)">{{ "QUOTES.QUOTESSENDAPPROVAL" | translate }}</button>
                            </div>
                            <div class="col-md-12 mt-5">
                                <button type="button" class="btn btn-success btn-block .bg-success" (click)="onclickAppovalQuote(loadingModal)">{{ "QUOTES.APPROVALPOLICIE" | translate }}</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <ng-template #loadingQuote>

        <div id="loading-result-quote" class="mb-5">
            
        </div>

    </ng-template>


    <!--div id="loading-result-quote" #ErrorQuote class="mb-5">
        <div class="alert aler-danger">
            {{ "QUOTES.ERROR1"  | translate }}
        </div>
    </!--div -->

    <div class="loadingModal">
        <ng-template #loadingModal let-c="close" let-d="dismiss">
            <div class="modal-body">
                <div class="loading-totalesModal">
                    <div class="spinner spinner-track spinner-primary spinner-lg mr-15"><span class="font-weight-boldest pl-10">{{ "GENERAL.LOADING" | translate }} ...</span></div>
                </div>
            </div>
        </ng-template>
    </div>

    <div class="requiredDocumentModal" >
        <span *ngIf="closeResult">
        <pre>{{closeResult}}</pre>
        </span>

        <div>
            <ng-template #requiredDocumentModal let-c="close" let-d="dismiss">
                <div class="modal-header">
                    <h4 class="modal-title font-weight-bolder">{{ "DOCUMENTS.REQUIRED_DOCUMENTS" | translate }}</h4>
                    <button type="button" class="close" aria-label="Close" (click)="d('')">
                    <span aria-hidden="true">&times;</span>
                    </button>
                </div>

                <div class="modal-body">
                    <div class="alert alert-primary">
                        <i class="fa fa-warning"></i> <strong>{{ "DOCUMENTS.REQUIRED_DOCUMENTS_LIFE" | translate}}</strong>
                    </div>

                    <div class="row my-5 align-items-left" *ngIf="hasLoadindRD">
                        <div class="col-1"><img src="/assets/media/misc/loading.gif" width="25px"></div>
                        <div class="col-11">{{ "DOCUMENTS.UPLOADLOADING" | translate }}</div>
                    </div>

                    <div class="row">
                        <div class="col-md-12">
                            <div class="row mt-5" *ngFor="let item of requiredDocument$ | async">
                                <div class="col-8 font-weight-boldest mt-2">{{ item.NombreDocumento }}</div>
                                <div class="col-4 text-right"><button type="button" (click)="clickDownloadRequiredDocument(loadingModal,item.IdTipoDocumento)" class="btn btn-primary btn-sm"><i class="fa fa-download"></i></button></div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="modal-footer">
                    <button type="button" class="btn btn-default text-dark" (click)="c('Close click')">{{ "INPUT.CLOSE" | translate}}</button>
                </div>
            </ng-template>
        </div>
    </div>

    <div class="loadingModal">
        <ng-template #loadingModal let-c="close" let-d="dismiss">
            <div class="modal-body">
                <div class="loading-totalesModal">
                    <div class="spinner spinner-track spinner-primary spinner-lg mr-15"><span class="font-weight-boldest pl-10">{{ "GENERAL.LOADING" | translate }} ...</span></div>
                </div>
            </div>
        </ng-template>
    </div>

    <div class="requiredUploadDocumentModal">
        <span *ngIf="closeResult">
        <pre>{{closeResult}}</pre>
        </span>


            <ng-template #requiredUploadDocumentModal let-c="close" let-d="dismiss">
                <div class="modal-header">
                    <h4 class="modal-title font-weight-bolder">{{ "DOCUMENTS.REQUIRED_DOCUMENTS" | translate }}</h4>
                    <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
                    <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="alert alert-primary mb-5">
                        <i class="fa fa-warning"></i> <strong>{{ "DOCUMENTS.UPLOAD_REQUIRED_DOCUMENTS_LIFE" | translate}}</strong>
                    </div>

                    <div class="row mb-4 align-items-left" *ngIf="hasLoadindRD" >
                        <div class="col-1"><img src="/assets/media/misc/loading.gif" width="25px"></div>
                        <div class="col-11">{{ "DOCUMENTS.UPLOADLOADING" | translate }}</div>
                    </div>

                    <div class="row mb-4 align-items-center" *ngFor="let item of requiredDocument$ | async">
                        <div class="col-12">
                            <label class="d-block" for="file{{ item.IdTipoDocumento }}">{{ item.NombreDocumento }}</label>
                            <div class="input-group is-invalid">
                                <div class="custom-file">
                                  <input type="file" class="custom-file-input" id="file{{ item.IdTipoDocumento }}" name="file{{ item.IdTipoDocumento }}" accept=".pdf" />
                                  <label class="custom-file-label " for="file{{ item.IdTipoDocumento }}">Buscar archivo...</label>
                                </div>
                                <div class="input-group-append">
                                    <button class="btn btn-secondary text-white requiredDocument-upload" *ngIf="!hasLoadindRD"  id="upload-file{{ item.IdTipoDocumento }}" type="button" (click)="onclickUploadRequiredDocument(loadingModal, item.IdTipoDocumento)"><i class="fas fa-cloud-upload-alt AUTH"></i>{{ "DOCUMENTS.UPLOAD_REQUIRED_DOCUMENT" | translate}}</button>
                                </div>
                                <div class="input-group-append" *ngIf="item.Cargado==1">
                                    <button class="btn btn-primary" id="download-file{{ item.IdTipoDocumento }}" type="button" (click)="onclickViewUploadRequiredDocument(loadingModal, item.IdTipoDocumento)"><i class="fa fa-eye"></i></button>
                                 </div>
                                 <div class="input-group-append border-0" *ngIf="item.Cargado==1">
                                    <span class="input-group-text border-0 bg-white"><i class="fa fa-check text-success"></i></span>
                                 </div>

                              </div>
                              <hr>
                        </div>
                    </div>
                </div>

                <div class="modal-body" *ngIf="hasLoadindRD">
                    
                </div>

                <div class="modal-footer">
                    <button type="submit" class="btn btn-success" (click)="c('Close click')">{{ "INPUT.CLOSE" | translate}}</button>
                </div>
            </ng-template>
    </div>
</div>

<ng-template
  #formError
  let-control="control"
  let-message="message"
  let-validation="validation"
>
  <ng-container
    *ngIf="control.hasError(validation) && (control.dirty || control.touched)">
    <div class="fv-plugins-message-container">
      <div class="fv-help-block">
        {{ message }}
      </div>
    </div>
  </ng-container>
</ng-template>